import React, { useEffect } from 'react'
import moment from 'moment'
import { FieldNames, IntradayRepeatTypes } from '../../../types/publishSchedule'
import { setFieldValue } from '../../../actions/publishSchedule'
import { DATE_FORMATS } from '../../../config'
import { usePublishSchedule } from '../hooks'
import { GenericDropdown } from './GenericDropdown'
import { DateTime } from './DateTime'

export const IntradayRepeat = () => {
  const [{ fieldValues }, dispatch] = usePublishSchedule()

  useEffect(() => {
    if (fieldValues.intradayRepeat === IntradayRepeatTypes.repeat && fieldValues.intradayRepeatUntil === undefined) {
      dispatch(setFieldValue(
        FieldNames.intradayRepeatUntil,
        moment(fieldValues.startTime || new Date()).add(1, 'minute').startOf('minute').toDate()
      ))
    }
  }, [
    fieldValues,
    dispatch,
  ])

  return (
    <>
      <GenericDropdown
        fieldName={FieldNames.intradayRepeat}
        fieldLabel="Intraday repeat"
        margin="normal"
      />
      {fieldValues.intradayRepeat !== IntradayRepeatTypes.none && (
        <GenericDropdown
          fieldName={FieldNames.intradayRepeatInterval}
          fieldLabel="Every"
        />
      )}
      {fieldValues.intradayRepeat === IntradayRepeatTypes.repeat && (
        <DateTime
          fieldName={FieldNames.intradayRepeatUntil}
          dateFormat={DATE_FORMATS.TIME_ONLY}
          showTimeSelectOnly
        />
      )}
    </>
  )
}
